import React from 'react';
import {FormattedMessage, injectIntl} from "react-intl";
import {hashHistory} from "react-router";
import {connect} from "react-redux";
import size from "lodash/size";
import {setQuestionPopupState} from "../../actions/A_Popups";
import {loadFeaturesSetupFeatures, saveFeaturesSetup} from "./featuresAsyncActions";
import {showQuoteSavedNotification} from "../Generic/SuccessNotification";
import {featuresSetupSetPendingFeatures} from "./featuresActions";

const FeaturesSetupFooter = (props) => {

  const {saveFeaturesSetup, updateItemCount, setQuestionPopupState, intl, featuresSetupSetPendingFeatures, group, catId,
    loadFeaturesSetupFeatures} = props;

  const redirectBack = () => {
    hashHistory.push("/newscope");
  }

  const handleFooterCancelClick = () => {
    if (updateItemCount) {
      setQuestionPopupState({
        showPopup: true,
        questionMessage: intl.formatMessage({id: "features.setup.footer.cancelQuestion"}),
        yesClick: () => {
          featuresSetupSetPendingFeatures({}); // clear pending updates
          loadFeaturesSetupFeatures(group, catId); // load features once again
        },
        noClick: null
      })
    } else {
      redirectBack();
    }
  }

  const handleFooterSaveClick = async () => {
    const saved = await saveFeaturesSetup(intl);
    if (saved) {
      showQuoteSavedNotification("features.setup.footer.savedSuccess.title", "features.setup.footer.savedSuccess.message");
    }
  }

  const saveDisabled = false;

  return (
    <div className="app-content-footer app-content-footer--fixed">
      <div className="app-content-footer__buttons">
        <button className="ui-button ui-button--blue" onClick={handleFooterCancelClick}>
          <span className="ui-button-text ui-button--uppercase">
            <FormattedMessage id={updateItemCount ? "messageBox.buttons.cancel" : "messageBox.buttons.back"}/>
          </span>
        </button>
        <button className={"ui-button ui-button--green ui-button--large" + (saveDisabled ? " ui-button--disabled" : "")}
                disabled={saveDisabled}
                onClick={handleFooterSaveClick}>
          <span className="ui-button-text ui-button--uppercase">
            <FormattedMessage id="messageBox.buttons.save"/>
          </span>
          {updateItemCount ? (
            <span className="updateCount updateCount--new" title="Unsaved item count">{updateItemCount}</span>
          ) : null}
        </button>
      </div>
    </div>
  )
};

const mapStateToProps = (store, ownProps) => {
  const {pendingFeatures} = store.featuresSetupState;
  const {location} = ownProps;

  return {
    catId: location.query.catId,
    group: location.query.group,
    updateItemCount: size(pendingFeatures),
  };
};

const mapDispatchToProps = {
  setQuestionPopupState,
  saveFeaturesSetup,
  featuresSetupSetPendingFeatures,
  loadFeaturesSetupFeatures,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupFooter)
);
